import { render, staticRenderFns } from "./OpenTodoSelectorDialog.vue?vue&type=template&id=84bc833a"
import script from "./OpenTodoSelectorDialog.vue?vue&type=script&lang=js"
export * from "./OpenTodoSelectorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports